import Label from './Label';

export type { LabelPlacement } from './Label';

export default Label;
